import { DirtyComponent } from '@shared/models';
import { DataLossService } from '@shared/services/data-loss.service';
import { ExclusionReasonsComponent } from './../student-exclusion-information/exclusion-reasons/exclusion-reasons.component';
import { ExclusionOverviewComponent } from './../student-exclusion-information/exclusion-overview/exclusion-overview.component';
import { exclusionsModel, pupilModel } from '@exclusionmodule/models';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  inject
} from '@angular/core';
import {
  ApiServiceService,
  LoggingService,
  MessagingService,
  NotificationService
} from '@oneeducation/app-core';
import { EXCLUSION_ENDPOINT } from '@shared/properties';
import { StudentExclusionLinkedDocumentListComponent } from '..';
import { DatePipe } from '@angular/common';
import { ACTION_TYPE } from '@exclusionmodule/constants';
import { UserRoleService } from '@usermanagement/services';
const err_stud_hist =
  'student not registered at this base when exclusion started';
const err_stud_not_reg = 'Student is not registered with this school';
const err_stud_already_excluded_api_msg =
  'This Student has already been Permanently excluded from this Base/Site combination.';
const err_stud_already_excluded =
  'The student has already been permanently excluded.';

@Component({
  selector: 'app-student-exclusion-details',
  templateUrl: './student-exclusion-details.component.html',
  styleUrls: ['./student-exclusion-details.component.scss'],
  standalone: false
})
export class StudentExclusionDetailsComponent
  implements OnInit, DirtyComponent
{
  private apiService = inject(ApiServiceService);
  private notificationService = inject(NotificationService);
  private loggingService = inject(LoggingService);
  private datePipe = inject(DatePipe);
  private dataLossService = inject(DataLossService);
  private messagingService = inject(MessagingService);
  private userService = inject(UserRoleService);

  @Input() exclusionId: number;
  @Input() accordionActiveState: boolean;
  @Input() pupilData: pupilModel;
  @Input() schoolId: number;
  @Input() isOffRollEditingEnabled: boolean;
  @Output() isExcludedValue: EventEmitter<boolean> = new EventEmitter();

  ExclusionDetails: string;
  Reasons: string;
  SupportOfficers: string;
  Meetings: string;
  Appeals: string;
  Documents: string;
  selectedAccordionPanel: string = 'ExclusionDetails';
  isCreateExclusion = false;
  isCreateClicked: boolean;
  @Output() goBack: EventEmitter<any> = new EventEmitter();
  childFormValidCheck: boolean;
  @ViewChild('overviewComponent')
  private overviewComponent: ExclusionOverviewComponent;
  @ViewChild('reasonsComponent')
  private reasonsComponent: ExclusionReasonsComponent;
  @ViewChild('linkedDocumentListComponent')
  private linkedDocumentComponent: StudentExclusionLinkedDocumentListComponent;
  exclusion: exclusionsModel;
  apiRoute: string;
  componentDetail = {
    componentName: 'Create Exclusion'
  };

  ngOnInit() {
    this.isCreateClicked = false;
    this.PopulateSectionHeadings();
    this.setAccordionSelection();
    if (this.exclusionId == 0) {
      this.isCreateExclusion = true;
    } else {
      this.isCreateExclusion = false;
    }
  }

  isChildFormValid(formValid: boolean) {
    this.childFormValidCheck = formValid;
  }

  createExclusion() {
    this.isCreateClicked = true;
    this.overviewComponent.validateForm();
    //Check if Reasons accordion is unopened. Undefined means not opened yet.
    if (this.reasonsComponent === undefined) {
      this.selectedAccordionPanel = 'ExclusionReasons'; //opening Reasons accordion
    }

    // Check whether the description is entered for all the files
    if (
      this.linkedDocumentComponent !== undefined &&
      this.linkedDocumentComponent.linkedDocuments !== null &&
      this.linkedDocumentComponent.linkedDocuments.length > 0 &&
      this.linkedDocumentComponent.linkedDocuments.some(
        (x) => x.fileDescription.length === 0
      )
    ) {
      this.notificationService.showError('File description required');
      this.isCreateClicked = false;
      return;
    }

    setTimeout(() => {
      this.reasonsComponent.validateForm();
      if (
        !this.overviewComponent.userFields.valid ||
        !this.reasonsComponent.userFields.valid
      ) {
        this.isCreateClicked = false;
        return;
      }
      //Save exclusion to database and upload documents
      this.saveExclusion();
    }, 500);
  }

  private checkIfCategoryLNCH() {
    const category = this.overviewComponent.userFields.controls.category.value;
    if (category == 'LNCH') {
      const numberOfLunchtimes =
        this.overviewComponent.userFields.controls.excludedLunchTimes.value;
      const excludedDays =
        this.overviewComponent.userFields.controls.excludedDays.value;

      //The database switches the values
      this.exclusion.excludedDays = numberOfLunchtimes;
      this.exclusion.excludedLunchTimes = excludedDays;
    }
  }

  saveExclusion() {
    this.apiRoute = this.getApiRoute();
    this.exclusion = new exclusionsModel();

    //Assign Overview fields
    this.exclusion = this.overviewComponent.userFields.value;
    this.exclusion.studentId = this.pupilData.studentId;
    // Find the school details of current selected school
    const school = this.userService.User.schools.find(
      (school) => school.schoolId === this.schoolId
    );
    // Set base name for current selected school
    this.exclusion.baseName = school?.schoolName;
    // Set dfe number for current selected school
    this.exclusion.dfeNumber = school?.dfeNumber;
    this.exclusion.categoryExtCode =
      this.overviewComponent.selectedCategoryExternalCode;
    this.exclusion.category =
      this.overviewComponent.getCategoryDescriptionFromIntExtCode(
        this.overviewComponent.userFields.controls.category.value,
        this.exclusion.categoryExtCode
      );
    this.exclusion.academicYear =
      this.overviewComponent.getFormattedAcademicYear(
        this.overviewComponent.academicYearAndTermBasedOnSelectedStartDate
          .academicYear
      );
    this.exclusion.term = this.overviewComponent.getFullTerm(
      this.overviewComponent.academicYearAndTermBasedOnSelectedStartDate
        .academicTerm
    );
    this.exclusion.baseId = this.overviewComponent.schoolId;

    //Assign Reasons fields
    this.exclusion.primaryReason =
      this.reasonsComponent.userFields.value.primaryReason;
    this.exclusion.reasons = [];
    this.exclusion.reasons.push({
      reason: this.reasonsComponent.userFields.value.primaryReason
    });

    if (
      this.reasonsComponent.userFields.value.additionalReason != null &&
      this.reasonsComponent.userFields.value.additionalReason !==
        this.reasonsComponent.userFields.value.primaryReason
    ) {
      this.reasonsComponent.userFields.value.additionalReason.forEach(
        (x) =>
          x !== this.reasonsComponent.userFields.value.primaryReason &&
          this.exclusion.reasons.push({
            reason: x
          })
      );
    }

    this.exclusion = this.overviewComponent.getExclusionWithFormattedDates(
      this.exclusion
    );
    this.checkIfCategoryLNCH();

    //Save Exclusion to Database
    this.apiService
      .postWithResponseHeader(this.apiRoute, this.exclusion)
      .subscribe({
        next: (x: any) => {
          if (x.headers.get('location') !== '') {
            this.exclusion.exclusionId = x.headers.get('location');
            this.dataLossService.removeComponentFromUnsavedChanges();
            this.notificationService.showSuccess(
              'Exclusion created successfully.'
            );
            //Send alert to refresh Pupil list to show latest excl correctly
            this.messagingService.sendAlert(this.exclusion.categoryExtCode);
          }
          //Save uploaded documents if any
          if (
            this.linkedDocumentComponent != undefined &&
            this.linkedDocumentComponent.linkedDocuments != null &&
            this.linkedDocumentComponent.linkedDocuments.length > 0
          ) {
            this.linkedDocumentComponent.exclusionId =
              this.exclusion.exclusionId;
            this.linkedDocumentComponent.postFile();
          } else {
            this.goBack.emit(ACTION_TYPE.CREATED);
          }
        },
        error: (x: any) => {
          this.isCreateClicked = false;
          if (
            x.error.statusCode === 409 &&
            x.error.code === '1.1.409.51' &&
            x.error.message.toUpperCase() === err_stud_hist.toUpperCase()
          ) {
            this.notificationService.showError(err_stud_not_reg);
          } else if (
            x.error.statusCode === 409 &&
            x.error.code === '1.1.409.51' &&
            x.error.message === err_stud_already_excluded_api_msg
          ) {
            this.notificationService.showError(err_stud_already_excluded);
          } else {
            this.notificationService.showError(
              'Something went wrong, please try again.'
            );
            this.loggingService?.logError(x);
          }
        }
      });
  }

  private getApiRoute() {
    return EXCLUSION_ENDPOINT.CreateExclusion;
  }

  PopulateSectionHeadings() {
    this.ExclusionDetails = 'Exclusion Details';
    this.Reasons = 'Exclusion Reasons';
    this.SupportOfficers = 'Support Officers';
    this.Meetings = 'Meetings';
    this.Appeals = 'Appeals';
    this.Documents = 'Supporting Documents';
  }

  setAccordionSelection() {
    if (this.accordionActiveState) {
      this.selectedAccordionPanel = 'ExclusionDocuments';
      return;
    }
  }

  navigateBackToExclusionList() {
    if (this.dataLossService.checkForUnsavedChanges()) {
      this.goBack.emit(ACTION_TYPE.CANCELLED);
    }
  }

  resetData() {
    //Reset Data method is required in Unsaved changes template
  }
  canDeactivate() {
    return this.dataLossService.isDirty();
  }
}
